import { createSelector } from 'reselect';

import * as utils from '../../shared/utils';
import { isUnsubscribed } from '../helpers/user';

const selectUser = (state) => state.user;

export const selectIsTrialMetadataUser = createSelector(
  selectUser,
  (user) => {
    const isTrialPlan = user.subscriptionFeatures?.planId === 'trial';
    const isMetadataCookie = utils.getCookie('metadata.utm_campaign') || localStorage.getItem('metadata.utm_campaign') || false;

    return Boolean((isTrialPlan || isUnsubscribed(user)) && isMetadataCookie);
  },
);

export default {
  selectIsTrialMetadataUser,
};
